import { useMemo } from 'react'
import { useFeatureFlag } from 'util/featureFlags'

// TODO: we could make this more general purpose in future for new menu items/areas.
const useHardwareBetaTag = (additionalCondition?: boolean) => {
  const enableBetaTagHardware = useFeatureFlag('enable_hardware_beta_tag', 'on') ?? false

  return useMemo(() => enableBetaTagHardware && (additionalCondition ?? true), [
    enableBetaTagHardware,
    additionalCondition,
  ])
}

export default useHardwareBetaTag
